import { QueryClient } from '@tanstack/react-query'
import type { FileRouteTypes } from '@tanstack/react-router'
import { createBrowserHistory, createRouter } from '@tanstack/react-router'

import { routeTree } from '@/routeTree.gen'
import { addToRouterHistory } from '@/utils/router/history'

const tanstackHistory = createBrowserHistory()

tanstackHistory.subscribe(() => {
  addToRouterHistory(tanstackHistory.location.pathname)
})

export const tanstackRouter = createRouter({ routeTree, history: tanstackHistory, notFoundMode: 'root', trailingSlash: 'preserve' })
declare module '@tanstack/react-router' {
  interface IRegister {
    router: typeof tanstackRouter
  }
}

export const tanstackQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      refetchOnWindowFocus: true,
      retry: false,
    },
  },
})

export type TValidRoutes = FileRouteTypes['to']
